import _taggedTemplateLiteralLoose from '@babel/runtime/helpers/taggedTemplateLiteralLoose';
import { css } from '@emotion/css';

var _templateObject;
var deleteIconSpacing = function deleteIconSpacing(marginLeft) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  .MuiChip-deleteIcon {\n    margin: 0;\n    margin-inline-start: ", "rem;\n  }\n"])), marginLeft);
};

export { deleteIconSpacing };
//# sourceMappingURL=styles.js.map
